<template>
	<div>
		<v-col class="registrasi">
			<div class="d-flex justify-space-between">
				<div class="font-size-14 font-weight-bold cl-agen-dark">Member Registration</div>
			</div>
			<template v-if="!loaderData">
				<div class="mt-5">
					<v-scroll-x-reverse-transition>
						<v-card class="pa-3 elevation-0 rounded-lg" outlined>
							<v-form ref="formRegistration" role="form">
								<v-row>
									<!-- product section -->
									<v-col cols="12" sm="12" md="4" class="align-stretch px-3 pt-3 px-md-4 pt-md-4">
										<v-card class="pa-4 pb-6 d-flex flex-column elevation-0 rounded-lg fill-height" outlined>
											<v-card-title class="pa-0 mb-4"><h5>Membership Information</h5></v-card-title>
											<v-row>
												<v-col cols="12" sm="12" md="12">
													<v-row>
														<v-col cols="12" sm="12" md="12" class="">
															<v-text-field
																label="Serial Code"
																color="red darken-3"
																class="input-regis"
																hide-details="auto"
																prepend-inner-icon="mdi-barcode"
																outlined
																dense
																ref="serial"
																v-model="params.serial"
																tabindex="1"
																:error-messages="(errorValidation !== undefined && errorValidation['serial'] !== undefined ) ? [errorValidation['serial']] : []"
																:rules="[rules.inputreq('Serial', params.serial)]"></v-text-field>
														</v-col>
														<v-col cols="12" sm="12" md="12" class="">
															<v-text-field
																label="Serial Pin"
																color="red darken-3"
																class="input-regis"
																hide-details="auto"
																prepend-inner-icon="mdi-key"
																outlined
																dense
																ref="pin_serial"
																v-model="params.pin"
																tabindex="2"
																:error-messages="(errorValidation !== undefined && errorValidation['pin'] !== undefined ) ? [errorValidation['pin']] : []"
																:rules="[rules.inputreq('Serial Pin', params.pin)]"></v-text-field>
														</v-col>
														<v-col cols="12" sm="12" md="12" class="">
															<v-text-field
																label="Upline Member ID"
																color="red darken-3"
																class="input-regis"
																hide-details="auto"
																prepend-inner-icon="mdi-account"
																outlined
																dense
																ref="upline_code"
																v-model="params.upline_network_code"
																tabindex="3"
																:error-messages="(errorValidation !== undefined && errorValidation['upline_network_code'] !== undefined ) ? [errorValidation['upline_network_code']] : []"
																:rules="rules.upline_code"
																@change="uplineCheck"></v-text-field>
																<div class="grey--text" v-if="uplineDataMember">{{uplineDataMember.member_name}}</div>
														</v-col>
														<v-col cols="12" sm="12" md="12" class="">
															<template v-if="isUplineExist">
																<div class="d-flex flex-row">
																	<v-icon large color="grey">mdi-account-network-outline</v-icon>
																	<div class="d-flex flex-column pl-3">
																		<small>Position</small>
																		<template v-if="params.position == 'L'"><h4 class="cl-primary">Left</h4></template>
																		<template v-else-if="params.position == 'R'"><h4 class="cl-primary">Right</h4></template>
																		<template v-else><span class="red--text font-size-10">You have not selected a node position</span></template>
																	</div>
																</div>
															</template>
															<template v-else>
																<v-card-subtitle class="py-0 px-0 font-weight-bold">Position</v-card-subtitle>
																<v-radio-group
																	v-model="params.position"
																	ref="position"
																	row
																	hide-details="auto"
																	class="mb-2 mt-1"
																	tabindex="4"
																	:rules="rules.position"
																	:error-messages="(errorValidation !== undefined && errorValidation['position'] !== undefined ) ? [errorValidation['position']] : []"
																>
																	<v-radio
																		label="Left"
																		value="L"
																		ref="positionL"
																	></v-radio>
																	<v-radio
																		label="Right"
																		value="R"
																		ref="positionR"
																	></v-radio>
																</v-radio-group>
															</template>
														</v-col>
													</v-row>
												</v-col>
											</v-row>
										</v-card>
									</v-col>
									
									<!-- personal data section -->
									<v-col cols="12" sm="12" md="8" class="align-stretch px-3 pt-3 px-md-4 pt-md-4">
										<v-card outlined class="pa-4 d-flex flex-column elevation-0 rounded-lg">
											<v-card-title class="pa-0 mb-4"><h5>Personal Member Information</h5></v-card-title>
											<v-row>
												<v-col cols="12" sm="12" md="6">
													<v-card outlined class="pa-5 d-flex flex-column elevation-0 rounded-lg fill-height">
														<v-row>
															<v-col cols="12" sm="12" md="12">
																<v-autocomplete 
																	label="Country"
																	placeholder="Choose Your Country"
																	hide-details="auto" 
																	no-data-text="No data available"
																	return-object
																	outlined
																	dense
																	color="red darken-3" 
																	item-color="red darken-3"
																	:items="countries" 
																	item-text="country_name" 
																	item-value="country_id" 
																	ref="country" 
																	v-model="params.country_select"
																	@change="setSelectedCountry"
																	:rules="[rules.inputreq('Country', params.country_id)]"
																	:error-messages="(errorValidation !== undefined && errorValidation['country_id'] !== undefined ) ? [errorValidation['country_id']] : []"
																	tabindex="5">
																		<template v-slot:selection="data">
																			<div class="d-flex align-center flex-row">
																				<v-img :src="data.item.country_flag" class="mr-2" width="20px" height="18px" cover></v-img>
																				<span>{{ data.item.country_name }}</span>
																			</div>
																		</template>
																		<template v-slot:item="data">
																			<div class="d-flex align-center flex-row">
																				<v-img :src="data.item.country_flag" class="mr-2" width="20px" height="18px" cover></v-img>
																				<span>{{ data.item.country_name }}</span>
																			</div>
																		</template>
																	</v-autocomplete>
															</v-col>
															<v-col cols="12" sm="12" md="12">
																<v-text-field
																	label="Fullname"
																	color="red darken-3"
																	class="input-regis"
																	hide-details="auto"
																	prepend-inner-icon="mdi-account"
																	outlined
																	dense
																	ref="name"
																	v-model="params.name"
																	tabindex="6"
																	@blur="params.bank_account_name = params.name"
																	:error-messages="(errorValidation !== undefined && errorValidation['name'] !== undefined ) ? [errorValidation['name']] : []"
																	:rules="[rules.inputreq('Member Fullname', params.name)]"></v-text-field>
															</v-col>
															<v-col cols="12" sm="12" md="12">
																<v-text-field
																	label="Email"
																	color="red darken-3"
																	class="input-regis"
																	prepend-inner-icon="mdi-email"
																	hide-details="auto"
																	v-model="params.email"
																	tabindex="7"
																	outlined
																	dense
																	:error-messages="(errorValidation !== undefined && errorValidation['email'] !== undefined ) ? [errorValidation['email']] : []"
																	:rules="rules.email"></v-text-field>
															</v-col>
															<v-col cols="12" sm="12" md="12">
																<v-text-field
																	label="Phone Number"
																	color="red darken-3"
																	class="input-regis"
																	prepend-inner-icon="mdi-cellphone"
																	v-model="params.mobilephone"
																	hide-details="auto"
																	maxlength="15"
																	:rules="rules.nohp"
																	outlined
																	dense
																	tabindex="8"
																	:error-messages="(errorValidation !== undefined && errorValidation['mobilephone'] !== undefined ) ? [errorValidation['mobilephone']] : []"
																	@keypress="onlyNumber"
																	@paste="validatePaste($event)">
																		<template v-slot:prepend>
																			<v-card outlined class="pa-3" color="#eee" style="margin-top: -8px; height: 40px;">
																				<h4 class="">{{ params.country_phone_code }}</h4>
																			</v-card>
																		</template>
																	</v-text-field>
															</v-col>
															<v-col cols="12" sm="12" md="12">
																<v-autocomplete 
																	label="Gender"
																	placeholder="Choose Gender"
																	hide-details="auto" 
																	no-data-text="No data available" 
																	outlined
																	dense
																	color="red darken-3" 
																	item-color="red darken-3"
																	:items="listGender" 
																	item-text="label" 
																	item-value="value" 
																	ref="gender" 
																	v-model="params.gender"
																	:rules="[rules.inputreq('Gender', params.gender)]"
																	:error-messages="(errorValidation !== undefined && errorValidation['gender'] !== undefined ) ? [errorValidation['gender']] : []"
																	tabindex="9"></v-autocomplete>
															</v-col>
														</v-row>

														<v-row>
															<v-col cols="12" sm="12" md="12">
																<v-menu 
																	v-model="birthDate"
																	:close-on-content-click="false"
																	:nudge-right="0"
																	transition="scale-transition"
																	offset-y min-width="290px">
																	<template v-slot:activator="{ on, attrs }">
																		<v-text-field
																			label="Birth Date"
																			color="red darken-3"
																			class="input-regis"
																			prepend-inner-icon="mdi-calendar"
																			readonly
																			v-bind="attrs"
																			v-on="on"
																			outlined
																			dense
																			hide-details="auto"
																			tabindex="10"
																			:error-messages="(errorValidation !== undefined && errorValidation['birth_date'] !== undefined ) ? [errorValidation['birth_date']] : []"
																			:value="convertDate(params.birth_date)"
																			:rules="[rules.inputreq('Birth Date', params.birth_date)]"></v-text-field>
																	</template>
																	<v-date-picker locale="en" first-day-of-week="0" color="red darken-3" :max="today" @input="birthDate = false" hide-details="auto" v-model="params.birth_date"></v-date-picker>
																</v-menu>
															</v-col>

															<v-col cols="12" sm="12" md="12">
																<v-text-field
																	label="Birth Place"
																	color="red darken-3"
																	class="input-regis"
																	prepend-inner-icon="mdi-map-marker-right-outline"
																	hide-details="auto"
																	v-model="params.birth_place"
																	tabindex="11"
																	outlined
																	dense
																	:error-messages="(errorValidation !== undefined && errorValidation['birth_place'] !== undefined ) ? [errorValidation['birth_place']] : []"
																	:rules="[rules.inputreq('Birth Place', params.birth_place)]"></v-text-field>
															</v-col>
														</v-row>
													</v-card>
												</v-col>

												<v-col cols="12" sm="12" md="6">
													<v-card outlined class="pa-5 d-flex flex-column elevation-0 rounded-lg fill-height">
														<v-row>
															<v-col cols="12" sm="12" md="12">
																<v-autocomplete
																	label="Select Identity Type" 
																	hide-details="auto" 
																	no-data-text="No data available" 
																	outlined
																	dense
																	color="red darken-3" 
																	item-color="red darken-3"
																	:items="(params.country_id == '121') ? ['NRIC/MYKAD', 'PASSPORT'] : ['PASSPORT']"
																	ref="identity_type" 
																	v-model="params.identity_type"
																	:rules="[rules.inputreq('Identity Type', params.identity_type)]"
																	:error-messages="(errorValidation !== undefined && errorValidation['identity_type'] !== undefined ) ? [errorValidation['identity_type']] : []"
																	tabindex="12"
																	@change="params.identity_no = ''"></v-autocomplete>
															</v-col>
															
															<v-col cols="12" sm="12" md="12" class="pt-0">
																<!-- maxlength="16" @keypress="onlyNumber" -->
																<v-text-field
																	v-if="params.identity_type == 'PASSPORT' || params.identity_type == 'NRIC/MYKAD'"
																	:label="(params.identity_type == 'PASSPORT') ? 'Passport Number' : (params.identity_type == 'NRIC/MYKAD') ? 'NRIC/MYKAD Number' : 'Identity Number'"
																	color="red darken-3"
																	class="input-regis"
																	prepend-inner-icon="mdi-card-account-details"
																	hide-details="auto"
																	v-model="params.identity_no"
																	ref="identityNo"
																	outlined
																	dense
																	tabindex="13"
																	:rules="rules.nomykad"
																	:error-messages="(errorValidation !== undefined && errorValidation['identity_no'] !== undefined ) ? [errorValidation['identity_no']] : []"
																	@paste="validatePaste($event, 'mykad')"
																	></v-text-field>
																<v-text-field
																	v-else
																	label="Identity Number"
																	color="red darken-3"
																	class="input-regis"
																	prepend-inner-icon="mdi-card-account-details"
																	hide-details="auto"
																	v-model="params.identity_no"
																	ref="identityNo"
																	outlined
																	dense
																	tabindex="14"
																	:rules="rules.nomykad"
																	:error-messages="(errorValidation !== undefined && errorValidation['identity_no'] !== undefined ) ? [errorValidation['identity_no']] : []"
																	@paste="validatePaste($event, 'mykad')"
																	@keypress="onlyNumber"
																	></v-text-field>
															</v-col>
														</v-row>

														<v-row>
															<v-col cols="12" class="d-none">
																<v-file-input
																	id="uploadIdentity"
																	hide-input
																	accept="image/png,image/jpeg,image/jpg,image/x-png"
																	prepend-icon="mdi-camera"
																	label="Browse File"
																	v-model="identity_image_upload"
																	:rules="rules.fileidentity"
																	@change="previewImageIdentity($event)"></v-file-input>
															</v-col>
															<v-col cols="12" class="d-flex align-center justify-space-between flex-column">
																<div style="display: block; position: relative; min-width: 160px; width: auto; max-width: 100%; margin: 0 auto;">
																	<v-img max-width="100%" width="auto" height="180px" class="rounded-lg d-block mx-auto" :src="(identity_image_url) ? identity_image_url : 'assets/image/no-image.png'" style="border: 1px solid #ddd;"></v-img>
																	<v-btn
																		elevation="3"
																		fab
																		icon
																		outlined
																		raised
																		rounded
																		small
																		class="btn-zoom"
																		@click="dialogZoomOpen(identity_image_url)"
																		v-if="identity_image_upload"
																	><v-icon color="#fff">mdi-magnify-plus-outline</v-icon></v-btn>
																	<v-btn
																		elevation="3"
																		color="error"
																		fab
																		icon
																		outlined
																		raised
																		rounded
																		x-small
																		style="position: absolute; top: -10px; right: -10px;background: #fff;"
																		@click="clearIdentityImg"
																		v-if="identity_image_upload"
																	><v-icon>mdi-close</v-icon></v-btn>
																</div>

																<v-btn
																	depressed
																	block
																	outlined
																	height="40px"
																	:color="(!identity_image_upload) ? 'red' : '#408285'"
																	class="text-capitalize mt-4"
																	tabindex="15"
																	:loading="btn_loading"
																	:disabled="(identity_image_upload) ? true : false"
																	@click="openIdentityUpload">
																	<v-icon>mdi-file-upload-outline</v-icon>
																	<span class="pr-2 ms-2">Upload {{ params.identity_type }}</span>
																</v-btn>

																<small class="red--text" v-if="(errorValidation !== undefined && errorValidation['identity_image'] !== undefined) || !identity_image_upload">
																	{{ (errorValidation !== undefined && errorValidation['identity_image'] !== undefined) ? errorValidation['identity_image'] : (!identity_image_upload) ? 'The identity card photo is required!' : '' }}
																</small>
															</v-col>
														</v-row>
													</v-card>
												</v-col>
											</v-row>
										</v-card>

										<v-card outlined class="pa-4 d-flex flex-column elevation-0 rounded-lg mt-4">
											<v-card-title class="pa-0 mb-4"><h5>Address Information</h5></v-card-title>
											<v-row>
												<v-col cols="12" sm="12" md="12">
													<v-textarea
														name="alamat"
														label="Address"
														color="red darken-3"
														v-model="params.address"
														hide-details="auto"
														prepend-inner-icon="mdi-map-marker-radius-outline"
														counter="255"
														maxlenght="255"
														rows="4"
														outlined
														dense
														tabindex="16"
														:rules="[rules.inputreq('Address', params.address)]"
														:error-messages="(errorValidation !== undefined && errorValidation['address'] !== undefined ) ? [errorValidation['address']] : []"
													></v-textarea>
												</v-col>
											</v-row>
										</v-card>

										<v-card outlined class="pa-4 d-flex flex-column elevation-0 rounded-lg mt-4">
											<v-card-title class="pa-0 mb-4"><h5>Bank Account Information</h5></v-card-title>
											<!-- bank info section -->
											<v-row>
												<v-col cols="12" sm="12" md="12" class="align-stretch px-3 pt-3 px-md-4">
													<v-card class="pa-4 elevation-0 rounded-lg fill-height" outlined>
														<v-row>
															<template v-if="params.country_id != '' && params.country_id != '121'">
																<v-col cols="12" sm="12" md="12">
																	<v-checkbox
																		v-model="isFillBlank"
																		class="ma-0"
																		color="red darken-3"
																		style=""
																		tabindex="17"
																		hide-details="auto"
																		required
																	>
																		<template slot="label">
																			<span class="">
																				Fill in the Blank
																			</span>
																		</template>
																	</v-checkbox>
																</v-col>
															</template>
															
															<v-col cols="12" sm="12" md="12">
																<template v-if="params.country_id == '121'">
																	<v-autocomplete
																		label="Bank Name"
																		hide-details="auto"
																		no-data-text="No data available"
																		color="red darken-3"
																		item-color="red darken-3"
																		prepend-inner-icon="mdi-bank-outline"
																		:items="banks"
																		item-text="bank_name"
																		item-value="bank_id"
																		v-model="params.bank_id"
																		tabindex="18"
																		return-object
																		outlined
																		dense
																		:rules="[rules.inputreq('Bank Name', params.bank_id)]"
																		:error-messages="(errorValidation !== undefined && errorValidation['bank_id'] !== undefined ) ? [errorValidation['bank_id']] : []"
																		@change="selectBank()"></v-autocomplete>
																</template>

																<template v-else>
																	<v-text-field
																		ref="bankName"
																		label="Bank Name"
																		color="red darken-3"
																		hide-details="auto"
																		prepend-inner-icon="mdi-bank-outline"
																		v-model="params.bank_name"
																		tabindex="19"
																		outlined
																		dense
																		@keyup="uppercase"
																		:rules="(isFillBlank) ? '' : [rules.inputreq('Bank Name', params.bank_name)]"
																		:error-messages="(errorValidation !== undefined && errorValidation['bank_name'] !== undefined ) ? [errorValidation['bank_name']] : []"
																	></v-text-field>
																</template>
															</v-col>
															<v-col cols="12" :sm="(isFillBlank) ? '12' : '6'" :md="(isFillBlank) ? '12' : '6'">
																<v-text-field
																	ref="accountNo"
																	:label="(isFillBlank) ? 'International Bank Account Number' : 'Bank Account Number'"
																	color="red darken-3"
																	hide-details="auto"
																	prepend-inner-icon="mdi-account-box-outline"
																	v-model="params.bank_account_no"
																	tabindex="20"
																	outlined
																	dense
																	:rules="(isFillBlank) ? '' : [rules.inputreq('Bank Account Number', params.bank_account_no)]"
																	:error-messages="(errorValidation !== undefined && errorValidation['bank_account_no'] !== undefined ) ? [errorValidation['bank_account_no']] : []"
																	@keypress="onlyNumber"></v-text-field>
															</v-col>
															<v-col cols="12" :sm="(isFillBlank) ? '12' : '6'" :md="(isFillBlank) ? '12' : '6'">
																<v-text-field
																	label="Account Name"
																	color="red darken-3"
																	hide-details="auto"
																	tabindex="21"
																	ref="bank_account_name"
																	prepend-inner-icon="mdi-account"
																	v-model="params.bank_account_name"
																	outlined
																	dense
																	:rules="[rules.inputreq('Account Name', params.bank_account_name)]"
																	:error-messages="(errorValidation !== undefined && errorValidation['bank_account_name'] !== undefined ) ? [errorValidation['bank_account_name']] : []"
																></v-text-field>
															</v-col>
														</v-row>
													</v-card>
												</v-col>
											</v-row>
										</v-card>

										<v-card class="py-3 px-4 elevation-0 rounded-lg mt-4" outlined>
											<v-checkbox
												v-model="isAgreed"
												class="ma-0"
												color="red darken-3"
												style="margin-bottom: -15px!important;"
												tabindex="22"
												required
											>
												<template slot="label">
													<span class="d-none d-sm-flex align-center">
														I have read and agree
														<v-btn x-small text color="red darken-3" @click="showTerms()" class="font-weight-bold py-0 mt-1 px-1 ml-1">
															the applicable terms &amp; conditions.
														</v-btn>
													</span>

													<span class="d-flex d-sm-none flex-column">
														<span class="d-flex flex-wrap">I have read and agree</span>
														<v-btn x-small text color="red darken-3" @click="showTerms()" class="d-flex flex-wrap justify-start text-left font-weight-bold py-0 px-0 mt-1">
															the applicable terms &amp; conditions.
														</v-btn>
													</span>
												</template>
											</v-checkbox>
										</v-card>

										<v-card class="py-3 px-4 elevation-0 rounded-lg mt-4" outlined>
											<v-row style="display: flex; align-items: end;    justify-content: end;">
												<v-col cols="6" sm="3" md="3">
													<v-btn large depressed block color="grey" class="white--text rounded-xl" :loading="btnLoadingProses" @click="goBack">
														<v-icon>mdi-arrow-left</v-icon>
														<span class="pl-2">Cancel</span>
													</v-btn>
												</v-col>
												<v-col cols="6" sm="3" md="3">
													<v-btn large depressed block color="red darken-3" class="white--text rounded-xl" :loading="btnLoadingProses" :disabled="(isAgreed) ? false : true" tabindex="21" @click="processInput">
														<v-icon>mdi-content-save-outline</v-icon>
														<span class="pl-2">Save</span>
													</v-btn>
												</v-col>
											</v-row>
										</v-card>
									</v-col>
								</v-row>
							</v-form>
						</v-card>
					</v-scroll-x-reverse-transition>
				</div>
			</template>

			<template v-else>
				<div class="mt-5">
					<LoadData :loading="loaderData"></LoadData>
				</div>
			</template>
		</v-col>

		<v-dialog
			v-model="dialogZoom"
			max-width="600"
		>
			<v-img width="600px" :src="(imgzoom) ? imgzoom : 'assets/image/no-image.png'" class="d-block mx-auto" style="border: 1px solid #ddd;"></v-img>
		</v-dialog>
		<ModalTerms ref="modalTerms" :terms="dataTerms"></ModalTerms>
		<ModalSuccess ref="modalSuccess" :msg="msgSuccess" :type="typeRegis"></ModalSuccess>
		<!-- <ModalConfirm ref="modalConfirm" :msg="msgConfirm" :type="typeConfirm" @action="processToClone"></ModalConfirm> -->
	</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import ModalTerms from './components/ModalTerms'
import ModalSuccess from './components/ModalSuccess'
// import ModalConfirm from './components/ModalConfirm'

function validateEmail(email) {
  var re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export default {
	components: {
		ModalSuccess,
		ModalTerms
	},
	data() {
		return {
			loaderData: false,
			loading: false,
			dialogZoom: false,
			imgzoom: '',
			btn_loading: false,
			btn_disabled: false,
			btnLoadingProses: false,
			companies: (process.env.VUE_APP_CLIENT_NAME !== undefined) ? process.env.VUE_APP_CLIENT_NAME : '',
			typeInput: 'password',
			icon: 'mdi-eye',
			page: 1,
			limit: '100',
			suksesInput: false,
			isUplineExist: false,
			selectedProduct: null,
			selectedBanktf: null,
			birthDate: '',
			identity_image_upload: null,
			identity_image_url: '',
			transfer_image_upload: null,
			transfer_image_url: '',
			tempRegister: null,
			dataTerms: null,
			isAgreed: false,
			isFillBlank: false,
			uplineDataMember: {},
			params: {
				sponsor_network_code: '',
				upline_network_code: '',
				serial: '',
				pin: '',
				name: '',
				email: '',
				identity_type: '',
				identity_no: '',
				mobilephone: '',
				gender: '',
				birth_place: '',
				birth_date: null,
				address: '',
				postalcode: '',
				subdistrict_id: '',
				city_id: '',
				province_id: '',
				country_select: {
					country_id: '121',
					country_iso_code: 'MY',
					country_phone_code: '+60',
					country_name: 'Malaysia',
					country_flag: 'https://flagcdn.com/h20/my.png',
					country_is_active: '1'
				},
				country_id: '121',
				country_phone_code: '+60',
				bank_id: '',
				bank_name: '',
				bank_account_name: '',
				bank_account_no: '',
				bank_province_id: '',
				bank_city: '',
				bank_branch: '',
				identity_image: null,
				position: '',
			},
			listGender: [
				{
					label: 'Male',
					value: 'Laki-laki'
				},
				{
					label: 'Female',
					value: 'Perempuan'
				}
			],
			listShippingMethod: [
				{
					label: 'Pick Up',
					value: 'pick up'
				},
				{
					label: 'Shipping Courier',
					value: 'courier'
				}
			],
			rules: {
				filetransfer: [
					v => !!v || 'The payment transfer proof file must not be empty',
					v => (v && v.size > 0) || 'The payment transfer proof file must not be empty',
				],
				fileidentity: [
					v => !!v || 'The scan/identity photo file must not be empty',
					v => (v && v.size > 0) || 'The scan/identity photo file must not be empty',
					v => (v && v.size < 3145728) || 'The size of the identity photo cannot exceed 3 MB',
				],
				input: [
					v => !!v || 'input is reuiqred'
				],
				inputreq(label, v) { 
					return !!v || label + ' is required'
				},
				sponsor_code: [
					v => !!v || 'Sponsor Member ID is required',
					v => ( v && this.sponsor_valid ) || "No member data found",
				],
				upline_code: [
					v => !!v || 'Upline ID is required',
					// v => ( v && this.upline_valid ) || "No member data found",
				],
				position: [
					v => !!v || 'Network Position must be selected',
				],
				// password: [
				// 	v => !!v || 'The password is required',
				// 	v => ( v && v.length >= 6 ) || "Password must not be less than 6 characters",
				// ],
				email: [
					v => !!v || 'Email is required',
					v => !!validateEmail(v) || 'Email format is incorrect',
				],
				nomykad: [
					v => !!v || 'Identity number is required',
					// v => ( v && v.length >= 16 ) || "The Identity number cannot be less than 16 digits",
					// v => ( v && v.length <= 16 ) || "The Identity number must not exceed 16 digits",
				],
				nohp: [
					v => !!v || 'Mobile phone is required',
					// v => ( v && v.length <= 16 ) || "Mobile phone cannot be less than 16 digits",
					v => ( v && v.length > 6 ) || "Mobile phone must not exceed 6 digits",
				],
			},
			msgSuccess: '',
			msgFailed: '',
			typeRegis: ''
		}
	},
	watch: {
  },
	computed: {
		...mapState('autentikasi', ['userData']),
		...mapState('jaringan', ['memberData']),
		...mapState('opsi', ['provinces', 'cities', 'subdistricts', 'banks', 'uplineData', 'countries']),
		...mapState(['errorValidation']),
	},
	methods: {
		...mapActions('jaringan', ['addRegistration', 'resetValidation']),
		...mapActions('opsi', ['getProvince', 'getCity', 'getSubdistrict', 'getBank', 'getUplineData', 'getCountries']),
		...mapMutations(['emptyErrorValidation']),

		uplineCheck() {
			
			this.emptyErrorValidation()
			this.uplineDataMember = ''
			this.params.sponsor_network_code = this.userData.member_network_code
			this.getUplineData({sponsor_network_code: this.params.sponsor_network_code, upline_network_code: this.params.upline_network_code}).then(() => {
					this.uplineDataMember = this.uplineData
			})
		},

		async validatePaste(val, type){
			let pasted = await val.clipboardData.getData('text')
			setTimeout(() => {
				if (!parseInt(pasted)) {
					if (type === 'mykad') {
						val.preventDefault()
					} else {
						val.preventDefault()
					}
				}
			})
		},

		showPassword() {
			this.typeInput = this.typeInput == 'text' ? 'password' : 'text'
			this.icon = this.icon == 'mdi-eye' ? 'mdi-eye-off' : 'mdi-eye'
		},

		goBack() {
			this.$router.push({name: 'membership'})
		},

		reset() {
			this.birthDate = null
			this.identity_image_upload = null
			this.transfer_image_upload = null
			this.identity_image_url = ''
			this.transfer_image_url = ''
			this.dataTerms = null
			this.isAgreed = false,
			this.uplineDataMember = {},
			this.params = {
				sponsor_network_code: '',
				upline_network_code: '',
				serial: '',
				pin: '',
				name: '',
				email: '',
				identity_type: '',
				identity_no: '',
				mobilephone: '',
				gender: '',
				birth_place: '',
				birth_date: null,
				address: '',
				subdistrict_id: '',
				city_id: '',
				postalcode: '',
				province_id: '',
				country_select: {
					country_id: '121',
					country_iso_code: 'MY',
					country_phone_code: '+60',
					country_name: 'Malaysia',
					country_flag: 'https://flagcdn.com/h20/my.png',
					country_is_active: '1'
				},
				country_id: '121',
				country_phone_code: '+60',
				bank_id: '',
				bank_name: '',
				bank_account_name: '',
				bank_account_no: '',
				identity_image: '',
				position: ''
			}
			this.params.sponsor_network_code = this.userData.member_network_code
			this.dialogZoom = false
			this.imgzoom = ''
		},

		openTransferUpload() {
			document.getElementById('uploadTransfer').click()
		},

		openIdentityUpload() {
			document.getElementById('uploadIdentity').click()
		},

		clearTransferImg() {
			this.transfer_image_upload = null
			this.transfer_image_url = ''
		},

		clearIdentityImg() {
			this.identity_image_upload = null
			this.identity_image_url = ''
		},

		inputPostalCode() {
			// if (this.params.postalcode) {
			// 	this.params.address = this.params.address + '\nPost. Code ' + this.params.postalcode
			// }
		},

		setSelectedCountry() {
			if (this.params.country_select) {
				this.params.country_id = this.params.country_select.country_id
				this.params.country_phone_code = this.params.country_select.country_phone_code
				
				this.params.identity_type = ''
				this.params.identity_no = ''
				this.params.bank_id = ''
				this.params.bank_name = ''
			}
		},

		changeProvince() {
			this.getCity({ province_id: this.params.province_id	})
			this.params.city_id = ''
			this.params.subdistrict_id = ''
		},

		changeCity() {
			this.getSubdistrict({ city_id: this.params.city_id	})
			this.params.subdistrict_id = ''
		},

		changeBankProvince() {
			this.getBankCity({ province_id: this.params.bank_province_id	})
			this.params.bank_city = ''
		},

		previewImageTransfer(event) {
			if (event) {
				this.transfer_image_url = URL.createObjectURL(this.transfer_image_upload)
				this.btn_disabled = false
			} else {
				this.transfer_image_url = null
				this.btn_disabled = true
			}
		},

		previewImageIdentity(event) {
			if (event && event.type != 'application/pdf') {
				this.identity_image_url = URL.createObjectURL(this.identity_image_upload)
				this.btn_disabled = false
			} else {
				this.identity_image_url = null
				this.btn_disabled = true
			}
		},

		dialogZoomOpen(img) {
			this.imgzoom = img
			this.dialogZoom = true
		},

		getTermContent() {
			this.dataTerms = {
				title: 'Terms & conditions',
				content: 'No data available.'
			}
		},

		showTerms() {
			this.$refs.modalTerms.modalShow()
		},

		getData() {
			this.params.sponsor_network_code = this.userData.member_network_code
			this.getCountries()
			this.getProvince()
			this.getBank()
			
		},

		async selectBank() {
			const selectedBank = await this.params.bank_id
			this.params.bank_id = selectedBank.bank_id
			this.params.bank_name = selectedBank.bank_name
		},

		async addRegistrationMitra() {
			this.params.sponsor_network_code = await this.userData.member_network_code
			// this.params.transfer_image = await this.transfer_image_upload
			this.params.identity_image = await this.identity_image_upload

			let phoneNumber = ''
			if (this.params.mobilephone) {
				if (this.params.mobilephone.substring(0, 1) == '0') phoneNumber = this.params.country_phone_code + this.params.mobilephone.substring(1, (this.params.mobilephone.length - 1))
				else if (('+' + this.params.mobilephone.substring(0, this.params.country_phone_code.length-1)) == this.params.country_phone_code) phoneNumber = this.params.mobilephone
				else phoneNumber = this.params.country_phone_code + this.params.mobilephone
			}

			let formDataRegis = new FormData()
			// formDataRegis.append('sponsor_network_code', this.params.sponsor_network_code)
			formDataRegis.append('upline_network_code', this.params.upline_network_code)
			formDataRegis.append('serial', this.params.serial)
			formDataRegis.append('pin', this.params.pin)
			formDataRegis.append('name', this.params.name)
			formDataRegis.append('email', this.params.email)
			formDataRegis.append('identity_type', (this.params.identity_type == 'NRIC/MYKAD') ? 'KTP' : 'PASPOR')
			formDataRegis.append('identity_no', this.params.identity_no)
			formDataRegis.append('mobilephone', phoneNumber)
			formDataRegis.append('gender', this.params.gender)
			formDataRegis.append('birth_place', this.params.birth_place)
			formDataRegis.append('birth_date', this.params.birth_date)
			formDataRegis.append('address', this.params.address + '\nPost. Code ' + this.params.postalcode)
			// formDataRegis.append('postalcode', this.params.postalcode)
			// formDataRegis.append('subdistrict_id', this.params.subdistrict_id)
			// formDataRegis.append('city_id', this.params.city_id)
			// formDataRegis.append('province_id', this.params.province_id)
			formDataRegis.append('country_id', this.params.country_id)
			formDataRegis.append('bank_id', (this.params.country_id == '121') ? this.params.bank_id : 0)
			formDataRegis.append('bank_name', this.params.bank_name)
			formDataRegis.append('bank_account_name', this.params.bank_account_name)
			formDataRegis.append('bank_account_no', this.params.bank_account_no)
			formDataRegis.append('identity_image', this.identity_image_upload)
			formDataRegis.append('position', this.params.position)

			// this.tempRegister = this.params
			// this.successRegistration(this.tempRegister, 'mitra')
			this.addRegistration(formDataRegis).then((response) => {
				this.emptyErrorValidation()
				this.tempRegister = this.params
				this.successRegistration(this.tempRegister, response.network_code, 'mitra')
				this.reset()
			}).catch(() => {
				// this.emptyErrorValidation()
				window.scrollTo(0,0)
				this.btnLoadingProses = false
			})
		},

		async processInput() {
			this.btnLoadingProses = await true
			if (this.$refs.formRegistration.validate()) {
				await this.addRegistrationMitra()
				setTimeout(() => {
					this.btnLoadingProses = false
				}, 1500);
			} else {
				window.scrollTo(0,0)
				this.btnLoadingProses = false
			}
		},

		successRegistration(data,network_code) {
			if(data) {
				this.msgSuccess = `
					<span class="d-block font-weight-bold cl-primary-dark font-size-12" style="width: 85%; margin: 0 auto;">Congratulations!</span><br>
					<span class="d-block font-weight-bold cl-primary-dark font-size-12" style="width: 85%; margin: 0 auto;">Your member registration has been successfully registered in the system ${this.companies}</span><br>
					<div class="d-block text-center my-4 pa-4" style="border: 2px solid #263238; border-radius: 10px">
						<span class="d-block mb-2"><span style="display: inline-block;">Member Name</span> :<br><strong class="primary--text">${data.name}</strong></span>
						<span class="d-block mb-2"><span style="display: inline-block;">Mobile Number</span> :<br><strong class="primary--text">${data.mobilephone}</strong></span>
						<span class="d-block mb-2"><span style="display: inline-block;">Member ID</span> :<br><strong class="primary--text">${network_code}</strong></span>
						<span class="d-block mb-2"><span style="display: inline-block;">Sponsor Member ID</span> :<br><strong class="primary--text">${data.sponsor_network_code}</strong></span>
						<span class="d-block mb-2"><span style="display: inline-block;">Network Position</span> :<br><strong class="primary--text">${data.position == "L" ? 'Left' : 'Right'}</strong></span>
					</div>
				`
				this.emptyErrorValidation()
				this.$refs.modalSuccess.modalShow()
			}
		},

		bulkRegister() {
			// this.params.sponsor_network_code = this.userData.member_network_code
			this.params.upline_network_code = 'COR1000001'
			this.params.serial = 'A000000001'
			// this.params.username = 'member23'
			// this.params.password = '123456'
			this.params.name = 'Member Dummy'
			this.params.email = 'member@dummy.com'
			this.params.identity_type = 'mykad'
			this.params.identity_no = '1234567890123456'
			this.params.mobilephone = '08123456789'
			this.params.gender = 'Perempuan'
			this.params.birth_place = 'Yogyakarta'
			this.params.birth_date = '2000-12-31'
			this.params.address = 'Jl. Yogyakarta'
			this.params.subdistrict_id = '538'
			this.params.city_id = '39'
			this.params.province_id = '5'
			this.params.country_id = '102'
			this.params.bank_company_bank_id = '1'
			this.params.bank_name = 'Bank BCA'
			this.params.bank_account_name = 'member bank'
			this.params.bank_account_no = '1234123412341234'
			// this.params.bank_city = 'Yogyakarta'
			// this.params.bank_province_id = '5'
			// this.params.bank_branch = 'Katamso'
			// this.params.mother_name = 'mother'
			// this.params.devisor_name = 'devisor'
			// this.params.devisor_relation = 'son'
			// this.params.transfer_bank_name = 'Bank BCA'
			// this.params.transfer_bank_account_no = '1234123412341234'
			// this.params.package_id = '1'
			// this.params.package_name = 'Sahabat'
			// this.params.package_price = '1956000'
			// this.params.social_media = ''

			if (this.listPackages && this.params.package_id) this.selectPackage()
			if (this.city && this.params.city_id) {
				this.getSubdistrict({ city_id: this.params.city_id	})
				setTimeout(() => {
					this.params.subdistrict_id = '538'
				}, 600)
			}
		},

		uppercase() {
      this.params.bank_name = this.params.bank_name.toUpperCase();
    }
	},

	async created() {
		this.loaderData = await true
		this.reset()
		this.params.upline_network_code = this.$route.query.upline
		this.params.position = this.$route.query.position
		if (this.$route.query.upline) {
			this.uplineCheck()
		}
		await this.emptyErrorValidation()
		// this.bulkRegister()
		await this.$store.dispatch('setPageTitle', 'Member Registration')
		await this.getData()
		this.getTermContent()

		setTimeout(() => { 
			this.loaderData = false
		}, 1000)
	}
};
</script>

<style lang="scss" scoped>
	.icon-upload-image {
		margin-top: -3.3rem !important;
		margin-left: 9.5rem !important;
	}

	.btn-zoom {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background: rgba(0,0,0,0.4);

		&:hover, &:focus {
			background: rgba(0,0,0,0.6);
		}
	}
</style>